import {Component, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ConfigTurnsService } from 'src/app/services/turns-services/config-turns-service/config-turns.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-config-help-card',
  templateUrl: './turns-config-help-card.component.html',
  styleUrls: ['./turns-config-help-card.component.scss']
})
export class TurnsConfigHelpCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() assistantActive;
  updateTurnsConfigHelpSubscription: Subscription;

  basicDataForm = new FormGroup({
    help: new FormControl(null, Validators.required)
  });

  constructor(private configTurnsService: ConfigTurnsService,
              private snackbarService: SnackBarService) {}

  ngOnInit() {}

  ngOnChanges() {
    if ((this.assistantActive === true) || (this.assistantActive === false)) {
      this.resetForm();
    }
  }

  public submitForm(e) {
    this.updateTurnsConfigHelpSubscription = this.configTurnsService.updateTurnsConfigHelp(this.basicDataForm.get('help').value).pipe(
      tap(o => this.configTurnsService.refreshTurnsConfig()),
      catchError(error => {
        this.snackbarService.open(error['data']['error'], 'error');
        this.configTurnsService.refreshTurnsConfig();
        return EMPTY;
      })
    ).subscribe();
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      help: this.assistantActive
    });
  }

  ngOnDestroy() {
    if (this.updateTurnsConfigHelpSubscription) { this.updateTurnsConfigHelpSubscription.unsubscribe(); }
  }
}
